import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DocumentoService } from '../../../services/documento.service';
import { AppTitleService } from '../../../services/app-title.service';
import { DateService, MY_DATE_FORMATS } from '../../../shared/date.service';
import { Documento } from '../../../models/Document';
import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AsyncPipe, Location } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ParticipanteService } from '../../../services/participante.service';
import { map, Observable, startWith } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { UnidadOrganizacional } from '../../../models/UnidadOrganizacional';
import { ServidorPublico } from '../../../models/ServidorPublico';
import { departamentoValidator } from '../../../commons/reasignar/reasignar.component';
import { UnidadOrganizacionalService } from '../../../services/unidad-organizacional.service';
import { ToastService, ScnackbarData, SnackbarStyles } from '../../../commons/toast.service';

import { AuthService } from '../../../services/auth.service';
import { AccionTarea } from '../../../models/Tarea';
import { TareaService } from '../../../services/tarea.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { UltimoUsoPipe } from '../../../pipes/ultimo-uso.pipe';
import { HttpErrorResponse } from '@angular/common/http';
import { UtilService } from '../../../services/util.service';
import { TableSelectedDocumentsComponent } from "../../../commons/table-selected-documents/table-selected-documents.component";
import { TreeAutocompleteComponent } from '../../../commons/tree-autocomplete/tree-autocomplete.component';

@Component({
    selector: 'app-tarea-nueva',
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-EC' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    ],
    imports: [
        MatTableModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatIconModule,
        AsyncPipe,
        TreeAutocompleteComponent,
        UltimoUsoPipe,
        MatProgressSpinnerModule,
        TableSelectedDocumentsComponent
    ],
    templateUrl: './tarea-nueva.component.html',
    styleUrl: './tarea-nueva.component.scss'
})
export class NuevaTareaComponent implements OnInit {
  taskData: number[];
  fetchingNewTask = false;

  currentUserID: string
  documentsInformation: Documento[] = []

  newTaskFormGroup = new FormGroup({
    departamento: new FormControl<UnidadOrganizacional>({ id: "", nombre: "", tipo: 0 }, {
      validators: [Validators.required, departamentoValidator()]
    }),
    participante: new FormControl<ServidorPublico>({ id: 0, usuario: "", apellidos: "", nombres: "", correo: "", estado: 0, telefono: "", telefonoMovil: "", departamento: "", cargo: "", titulo: "", ciruc: "", fechaUso: "" }, {
      validators: [Validators.required]
    }),
    maxDate: new FormControl(new Date(new Date().setDate(new Date().getDate() + 1)), {
      validators: [Validators.required]
    }),
    comment: new FormControl("", {
      validators: [
        Validators.required,
        Validators.maxLength(255)
      ]
    })
  })
  participantes: ServidorPublico[] = []
  participantesFiltered?: Observable<ServidorPublico[]>

  departamentos: UnidadOrganizacional[] = []
  departamentosFiltered?: Observable<UnidadOrganizacional[]>

  snackbarData: ScnackbarData = {}
  minDate = new Date(new Date().setDate(new Date().getDate() + 1))

  constructor(
    private router: Router,
    documentoService: DocumentoService,
    private unidadOrganizacionalService: UnidadOrganizacionalService,
    private utilService: UtilService,
    private tareaService: TareaService,
    private toast: ToastService,
    private authService: AuthService,
    private dateService: DateService,
    private participanteService: ParticipanteService,
    private location: Location
  ) {
    inject(AppTitleService).setTitle("Nueva tarea");

    const navigation = this.router.getCurrentNavigation();
    if (!navigation) {
      router.navigateByUrl("/borrador")
    }
    this.taskData = navigation?.extras.state?.["documentIDs"]

    this.taskData.forEach((id) => {
      documentoService.getById(id).subscribe({
        next: (response) => {
          this.documentsInformation = [...this.documentsInformation, response]
        }
      })
    })
    this.currentUserID = this.authService.getTokenData()!.id;
  }

  ngOnInit(): void {
    this.newTaskFormGroup.controls.participante.disable()
    this.unidadOrganizacionalService.getDepartamentosTree().subscribe({
      next: (response) => {
        this.departamentos = response
      }
    })

    //this.newTaskFormGroup.get("maxDate")?.setValue(new Date());
    this.utilService.getFechaSugerida(new Date()).subscribe({
      next:(res:any)=>{
        this.newTaskFormGroup.get("maxDate")?.setValue(new Date(res));
      }
    });
  }

  trackDepartamentoChanges(value: any) {
      if ((value as UnidadOrganizacional).id) {
        this.newTaskFormGroup.controls.departamento.setValue(value)
        this.participanteService.getServidoresPorDepartamento((value as UnidadOrganizacional).id).subscribe({
          next: (response) => {
            response = response.filter(participante => participante.id.toString() !== this.currentUserID);
            if (response.length > 0) {
              response.sort(function (a, b) {
                if (a.apellidos > b.apellidos) { return 1; }
                if (a.apellidos < b.apellidos) { return -1; }
                return 0;
              });
              this.participantes = response
              this.participantesFiltered = this.newTaskFormGroup.controls.participante.valueChanges.pipe(
                startWith(''),
                map(value => {
                  const nombres = typeof value === 'string' ? value : value?.nombres;
                  return nombres ? this._filterParticipante(nombres as string) : this.participantes.slice();
                }),
              );
              this.newTaskFormGroup.controls.participante.enable()
            } else {
              this.snackbarData.message = "Sin usuarios en el departamento!"
              this.snackbarData.style = SnackbarStyles.Error
              this.snackbarData.iconName = "error"
              this.toast.show(this.snackbarData)
            }
          }
        })
      } else {
        this.participantes = []
        this.participantesFiltered = undefined
        this.newTaskFormGroup.controls.participante.setValue(null)
      }
  }

  onCrearTareaSubmit() {
    this.fetchingNewTask = true
    let accionTareas: AccionTarea[] = []
    const participante = this.newTaskFormGroup.controls.participante.value
    const maxDate = this.newTaskFormGroup.controls.maxDate.value
    const comment = this.newTaskFormGroup.controls.comment.value
    this.documentsInformation.forEach(document => {
      const accionTarea: AccionTarea = {
        id: document.idTarea,
        idParticipante: participante!.id,
        fechaExpira: this.dateService.formatDateToCustomStringNoTime(maxDate!),
        comentario: comment!
      }
      accionTareas.push(accionTarea)
    });

    this.tareaService.nuevaTarea(accionTareas).subscribe({
      next: (_) => {
        this.snackbarData.message = "Tarea creada"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"
        this.fetchingNewTask = false
        this.toast.show(this.snackbarData)
        this.utilService.callTasks();
        this.location.back()
      },
      error: (response: HttpErrorResponse) => {
        if (response.error == "Nueva tarea existente") {
          this.snackbarData.message = "El usuario ya tiene una tarea asignada"
        } else {
          this.snackbarData.message = "Error al crear la tarea"
        }
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.fetchingNewTask = false
        this.toast.show(this.snackbarData)
      }
    })
  }

  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDate(date)
  }

  displayParticipanteFn(participante: ServidorPublico): string {
    return participante && participante.nombres ? participante.nombres.trim() + ' ' + participante.apellidos.trim() : '';
  }

  private _filterParticipante(filter: string): ServidorPublico[] {
    const filterValue = filter.toLowerCase();

    return this.participantes.filter(participante =>
      participante.nombres.toLowerCase().includes(filterValue) ||
      participante.apellidos.toLowerCase().includes(filterValue) ||
      participante.cargo?.toLowerCase().includes(filterValue) ||
      participante.ciruc.includes(filterValue));
  }

  displayDepartamentoFn(departamento: UnidadOrganizacional): string {
    return departamento && departamento.nombre ? departamento.nombre : '';
  }

  private _filterDepartamento(filter: string): UnidadOrganizacional[] {
    const filterValue = filter.toLowerCase();

    return this.departamentos.filter(departamento =>
      departamento.nombre.toLowerCase().includes(filterValue));
  }
  selectAllText(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    input.select();
  }

  onCancel() {
    this.location.back()
  }

}
